// const source = 'podsDataTable'

function fn () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'agenti-report-pdp',
      title: 'Report PDP',
      // data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': fn,
}
